import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
// components
import Page from '../componentes/Page';
// sections
import LoginForm from '../componentes/forms/LoginForm';
import { useCentro } from '../contextos/CentroContext';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const [loader, setLoader] = React.useState(false);
  const { centro } = useCentro();

    return (
      <Page title={`Login | ${centro.nombre}`}>
        <Backdrop
          sx={{ color: '#103996', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <RootStyle>

          <Container maxWidth="sm">
            <ContentStyle>
              <Typography variant="h4" gutterBottom>
                {centro.nombre}
              </Typography>

              <LoginForm setLoader={setLoader}/>

            </ContentStyle>
          </Container>
        </RootStyle>
      </Page>
    );
}
